import storage from 'redux-persist/lib/storage'

let frozen = false

export const freezeOrganizationPersistence = () => {
  frozen = true
}

export const resumeOrganizationPersistence = () => {
  frozen = false
}

// Pausing redux-persist does not cancel writes already queued by its persistoid. A stale document
// must also stop those writes from replacing the active tab's authentication and account state.
export const organizationStorage = {
  getItem: storage.getItem,
  setItem: (key: string, value: string) => (frozen ? Promise.resolve() : storage.setItem(key, value)),
  removeItem: (key: string) => (frozen ? Promise.resolve() : storage.removeItem(key)),
}
